import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NarrativeComponent from 'components/Narrative';

class Narrative extends Component {
  componentDidMount() {
    this.loadNarrative();
  }

  componentDidUpdate(prevProps) {
    const { match: { params: { id } } } = this.props;
    const { match: { params: { id: prevId } } } = prevProps;

    if (prevId !== id) {
      this.loadNarrative();
    }
  }

  loadNarrative() {
    const {
      match: { params: { id } },
      getNarrative,
      resetAll,
      setAutoNavigation,
    } = this.props;

    resetAll();
    setAutoNavigation(false);
    getNarrative(id);
  }

  render() {
    const { match: { params: { id } }, actualContext } = this.props;

    if (!actualContext || actualContext.id !== parseInt(id, 10)) {
      return null;
    }
    return (<NarrativeComponent id={parseInt(id, 10)} />);
  }
}

Narrative.propTypes = {
  getNarrative: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  setAutoNavigation: PropTypes.func.isRequired,
  resetAll: PropTypes.func.isRequired,
  actualContext: PropTypes.object,
};

Narrative.defaultProps = {
  actualContext: null,
};

export default Narrative;



// WEBPACK FOOTER //
// ./src/routes/Narrative/components/index.jsx